/* Insight metrics are built in <ModuleName>_<ProcessName> fashion.
*  For example, STOW_SCRUB indicates metric for Stow module with Scrub operation.
* */
export const InsightMetrics = {
    INDUCT_INDUCT: "INDUCT_INDUCT",
    STOW_STOW: "STOW_STOW"
};